module.exports = __webpack_public_path__ + "assets/img/wenhao.d10b3f9f.svg";